import React, {useEffect, useState} from 'react';
import WebView from 'react-native-webview';
import BottomSheet from '../../../../../Interface/BottomSheet';
import {Dimensions, View} from 'react-native';
import {Loading} from '../../../../../Interface/Loadings/Loading';
import { CloseButton, CloseButtonIcon } from './styles';
import { startCheckoutForegroundService, stopCheckoutForegroundService } from '../../../../../../utils/foregroundService';

interface Props {
  uri: string;
  status: string;
  onCancel: () => void;
  onLoaded: () => void
}

export default function StripeWebview3ds({
  uri,
  status,
  onCancel,
  onLoaded,
}: Props) {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!uri) return;
    startCheckoutForegroundService();
    return () => {
      stopCheckoutForegroundService();
    };
  }, [uri]);



  return (
    <BottomSheet isOpen={!!uri} onClose={onCancel}>
      <View style={{height: Dimensions.get('window').height * 0.9}}>
        {!loaded || status === 'processing' && <Loading />}
        <CloseButton onPress={onCancel}>
          <CloseButtonIcon name="x" />
        </CloseButton>
        <WebView
          style={{flex: 1}}
          source={{uri}}
          onLoad={() => {
            setLoaded(true);
            onLoaded();
          }}
        />
      </View>
    </BottomSheet>
  );
}
